import { render, staticRenderFns } from "./BasicInfoUpdateDateModals.vue?vue&type=template&id=f5319c9e&"
import script from "./BasicInfoUpdateDateModals.vue?vue&type=script&lang=js&"
export * from "./BasicInfoUpdateDateModals.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfoUpdateDateModals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports